import { render, staticRenderFns } from "./FSTopRight.vue?vue&type=template&id=dbefda64&scoped=true"
import script from "./FSTopRight.vue?vue&type=script&lang=js"
export * from "./FSTopRight.vue?vue&type=script&lang=js"
import style0 from "./FSTopRight.vue?vue&type=style&index=0&id=dbefda64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbefda64",
  null
  
)

export default component.exports